import {EventEmitter, Injectable, Output} from '@angular/core';
import {AuthenticationService} from '../../sdk/service/authentication.service';
import {BusinessDetails, PrepaidServicesStatusInfo, UserBusinessListItem, WebBusinessService} from 'web-angular-client';

/**
 * This class provides as a means of communication for services to 'tell' the layout component that elements on the
 * menu bar, side-bar etc need to be updated following an update to certain information. The layout component also
 * subscribes to the load event so that it its information is dynamically updated every time a load is called by
 * another service.
 */
@Injectable({
    providedIn: 'root'
})
export class LayoutService
{
    businessDetails: BusinessDetails = null;
    /** true when the most recent business-details load failed; reset by the next successful load */
    businessDetailsLoadFailed = false;
    /** subscribing to the load member will give you a new business details object everytime an 'emit' happens */
    @Output() public load = new EventEmitter<BusinessDetails>();
    /** emits when a business-details load fails, so subscribers can surface an unavailable state */
    @Output() public loadFailed = new EventEmitter<void>();
    @Output() public businessList = new EventEmitter<UserBusinessListItem[]>();
    @Output() public prepaidServicesStatusInfo: EventEmitter<PrepaidServicesStatusInfo> = new EventEmitter<PrepaidServicesStatusInfo>();

    constructor(private webBusinessService: WebBusinessService, private authenticationService: AuthenticationService)
    {
    }

    /**
     * Calling this method will cause anything subscribed to the 'load' member to emit the latest business details
     * object, or the 'loadFailed' member to emit when the load fails (the last successfully cached details are kept).
     */
    loadBusinessDetails()
    {
        this.webBusinessService.getBusinessDetails().subscribe({
            next: (businessDetails) =>
            {
                this.businessDetailsLoadFailed = false;
                this.businessDetails = businessDetails;
                this.load.emit(this.businessDetails);
            },
            error: () =>
            {
                this.businessDetailsLoadFailed = true;
                this.loadFailed.emit();
            }
        });
    }

    /** calling this method will cause anything subscribed to the 'businessList' member to emit the latest business list object */
    loadBusinessListForUser()
    {
        this.webBusinessService.getBusinessListForUser()
            .subscribe({
                next: (businessList) =>
                {
                    this.businessList.emit(businessList);
                }
            });
    }

    loadPrepaidServicesStatusInfo(): void
    {
        if (this.authenticationService.isLoggedIn())
        {
            this.webBusinessService.getPrepaidServicesStatus()
                .subscribe((prepaidServicesStatusInfo: PrepaidServicesStatusInfo) =>
                {
                    this.prepaidServicesStatusInfo.emit(prepaidServicesStatusInfo);
                });
        }
    }
}